import { Component, OnInit } from '@angular/core';
import PerfectScrollbar from 'perfect-scrollbar';
import { title } from 'process';

declare const $: any;

//Metadata
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    icontype: string;
    collapse?: string;
    children?: ChildrenItems[];
}

const assetID = 0
export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

let adminMenu = [
    // {
    //     path: '/cms-dashboard',
    //     title: 'CMS Dashboard',
    //     type: 'sub',
    //     icontype: 'home',
    //     collapse: 'cmsdashboard',
    //     children: [
    //         { path: 'geo-view', title: 'Geo View', ab: 'GV', icontype: 'map' },
    //         { path: 'site-view', title: 'Site View', ab: 'SV', icontype: 'place' }

    //     ]
    // },
    {
        path: '/geo-view',
        title: 'Geo View',
        type: 'link',
        icontype: 'map'
    },
    {
        path: '/site-view',
        title: 'Site View',
        type: 'link',
        icontype: 'place'
    },
    {
        path: '/usermaster',
        title: 'User Master',
        type: 'link',
        icontype: 'manage_accounts'
    },
    {
        path: '/iot-devices',
        title: 'Iot Devices',
        type: 'link',
        icontype: 'speaker_phone'
    },
    {
        path: '',
        title: 'Site Master',
        type: 'sub',
        icontype: 'workspaces',
        collapse: 'sitemaster',
        children: [
            { path: 'site-master', title: 'Sites', ab: 'SM', icontype: 'place' },
            { path: 'site-mapping', title: 'Site User Mapping', ab: 'UM', icontype: 'add_location' },
            { path: 'alertreciver', title: 'Alert/Alarm Reciver', ab: 'UM', icontype: 'add_location' }
        ]
    },
    {
        path: '/asset-master',
        title: 'Asset Master',
        type: 'link',
        icontype: 'important_devices'
    },
    {
        path: '',
        title: 'AMC',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'AMC',
        children: [
            { path: 'amcmaster', title: 'AMC', ab: 'AM', icontype: 'card_membership' },
            { path: 'subscription', title: 'Subscription', ab: 'SM', icontype: 'subscriptions' }
        ]
    },
    {
        path: '',
        title: 'Reports',
        type: 'sub',
        icontype: 'multiline_chart',
        collapse: 'Reports',
        children: [
            { path: 'asset-list', title: 'Asset List', ab: 'AL', icontype: 'list' },
            { path: 'user-list', title: 'User List', ab: 'UL', icontype: 'vertical_split' },
            { path: 'amcmaster', title: 'AMC & Subscription status', ab: 'AS', icontype: 'subscriptions' },
            { path: 'energy-consumption', title: 'Energy Consumption Report', ab: 'AS', icontype: 'description' },
            { path: 'hourly-energy-report', title: 'Hourly Energy Report', ab: 'AS', icontype: 'description' },
            { path: 'asset-health', title: 'Asset Health Report', ab: 'AS', icontype: 'description' }
        ]
    },
    {
        path: '',
        title: 'Master',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'master',
        children: [
            { path: 'category-master', title: 'Category Master', ab: 'CM', icontype: 'card_membership' },
            { path: 'periodic-test-matser', title: 'Periodic Test matser', ab: 'PM', icontype: 'list_alt' },
            { path: 'order-enquiry-view', title: 'Order Enquiry', ab: 'OE', icontype: 'assignment' },
            { path : 'user-activity-log' , title : 'User Activity log' , ab: 'UA' ,  icontype: 'assignment'}
        ]
    },
    {
        path: '/device-management',
        title: 'Device Management',
        type: 'link',
        icontype: 'important_devices'
    }
]

let salesmanager = [
    // {
    //     path: '/cms-dashboard',
    //     title: 'CMS Dashboard',
    //     type: 'sub',
    //     icontype: 'home',
    //     collapse: 'cmsdashboard',
    //     children: [
    //         { path: 'geo-view', title: 'Geo View', ab: 'GV', icontype: 'map' },
    //         { path: 'site-view', title: 'Site View', ab: 'SV', icontype: 'place' }

    //     ]
    // },
    {
        path: '/geo-view',
        title: 'Geo View',
        type: 'link',
        icontype: 'map'
    },
    {
        path: '/site-view',
        title: 'Site View',
        type: 'link',
        icontype: 'place'
    },
   
    {
        path: '',
        title: 'Alerts',
        type: 'sub',
        icontype: 'add_alert',
        collapse: 'Alerts',
        children: [
            { path: 'alert-logs', title: 'Alert Log', ab: '' ,icontype: 'place'},
            { path: 'alert-settings', title: 'Alert Settings', ab: '' ,icontype: 'place'}
        ]
    },
    {
        path: '/site-audit',
        title: 'Site Audit',
        type: 'link',
        icontype: 'card_membership'
    },
    {
        path: '',
        title: 'Preventive Maintenance',
        type: 'sub',
        icontype: 'schedule',
        collapse: 'Preventive',
        children: [
            { path: 'preventive-maintenance', title: 'Preventive Maintenance', ab: '' ,icontype: 'library_add'}
        ]
    },
    {
        path: '/repair-maintenance',
        title: 'Repair & Maintenance',
        type: 'link',
        icontype: 'engineering'
    },
    {
        path: '/periodic-test',
        title: 'Periodic Test',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/custmer_complaints',
        title: 'Customer Complaints',
        type: 'link',
        icontype: 'local_police'
    },
    {
        path: '',
        title: 'Reports',
        type: 'sub',
        icontype: 'multiline_chart',
        collapse: 'Reports',
        children: [
            { path: 'asset-list', title: 'Asset List', ab: 'AL', icontype: 'list' },
            { path: 'user-list', title: 'User List', ab: 'UL', icontype: 'vertical_split' },
            { path: 'amcmaster', title: 'AMC & Subscription status', ab: 'AS', icontype: 'subscriptions' },
            { path: 'energy-consumption', title: 'Energy Consumption Report', ab: 'AS', icontype: 'description' },
            { path: 'hourly-energy-report', title: 'Hourly Energy Report', ab: 'AS', icontype: 'description' },
            { path: 'asset-health', title: 'Asset Health Report', ab: 'AS', icontype: 'description' }
        ]
    },
    {
        path: '',
        title: 'AMC',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'AMC',
        children: [
            { path: 'amcmaster', title: 'AMC', ab: 'AM', icontype: 'card_membership' },
            { path: '', title: 'Subscription', ab: 'SM', icontype: 'subscriptions' }
        ]
    },
     {
        path: '/asset-register',
        title: 'Asset Register',
        type: 'link',
        icontype: 'important_devices'
    },
    {
        path: '/help',
        title: 'Help',
        type: 'link',
        icontype: 'engineering'
    }
];

let customerserviceexecutive = [
    // {
    //     path: '/cms-dashboard',
    //     title: 'CMS Dashboard',
    //     type: 'sub',
    //     icontype: 'home',
    //     collapse: 'cmsdashboard',
    //     children: [
    //         { path: 'geo-view', title: 'Geo View', ab: 'GV', icontype: 'map' },
    //         { path: 'site-view', title: 'Site View', ab: 'SV', icontype: 'place' }
    //     ]
    // },
    {
        path: '/geo-view',
        title: 'Geo View',
        type: 'link',
        icontype: 'map'
    },
    {
        path: '/site-view',
        title: 'Site View',
        type: 'link',
        icontype: 'place'
    },
    {
        path: '',
        title: 'Alerts',
        type: 'sub',
        icontype: 'add_alert',
        collapse: 'Alerts',
        children: [
            { path: 'alert-logs', title: 'Alert Log', ab: '' ,icontype: 'history'},
            { path: 'alert-settings', title: 'Alert Settings', ab: '' ,icontype: 'settings_applications'}
        ]
    },
    {
        path: '/site-audit',
        title: 'Site Audit',
        type: 'link',
        icontype: 'card_membership'
    },
    {
        path: '',
        title: 'Preventive Maintenance',
        type: 'sub',
        icontype: 'schedule',
        collapse: 'Preventive',
        children: [
            { path: 'preventive-maintenance', title: 'Preventive Maintenance', ab: '' ,icontype: 'library_add'}
        ]
    },
    {
        path: '/repair-maintenance',
        title: 'Repair & Maintenance',
        type: 'link',
        icontype: 'engineering'
    },
    {
        path: '/periodic-test',
        title: 'Periodic Test',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/custmer_complaints',
        title: 'Customer Complaints',
        type: 'link',
        icontype: 'local_police'
    },
    {
        path: '',
        title: 'Reports',
        type: 'sub',
        icontype: 'multiline_chart',
        collapse: 'Reports',
        children: [
            // { path: '', title: 'Asset List', ab: 'AL', icontype: 'list' },
            // { path: '', title: 'User List', ab: 'UL', icontype: 'vertical_split' },
            { path: '', title: 'AMC & Subscription status', ab: 'AS', icontype: 'subscriptions' },
            { path: 'energy-consumption', title: 'Energy Consumption Report', ab: 'AS', icontype: 'description' },
            { path: 'hourly-energy-report', title: 'Hourly Energy Report', ab: 'AS', icontype: 'description' },
            { path: 'asset-health', title: 'Asset Health Report', ab: 'AS', icontype: 'description' }
        ]
    },
    {
        path: '',
        title: 'AMC',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'AMC',
        children: [
            { path: 'amcmaster', title: 'AMC', ab: 'AM', icontype: 'card_membership' },
            { path: 'subscription', title: 'Subscription', ab: 'SM', icontype: 'subscriptions' }
        ]
    },
    {
        path: '/asset-register',
        title: 'Asset Register',
        type: 'link',   
        icontype: 'important_devices'
    },{
        path: '/help',
        title: 'Help',
        type: 'link',
        icontype: 'engineering'
    }
];

let fieldengineer = [
    // {
    //     path: '/cms-dashboard',
    //     title: 'CMS Dashboard',
    //     type: 'sub',
    //     icontype: 'home',
    //     collapse: 'cmsdashboard',
    //     children: [
    //         { path: 'geo-view', title: 'Geo View', ab: 'GV', icontype: 'map' },
    //         { path: 'site-view', title: 'Site View', ab: 'SV', icontype: 'place' }

    //     ]
    // },

    {
        path: '/geo-view',
        title: 'Geo View',
        type: 'link',
        icontype: 'map'
    },
    {
        path: '/site-view',
        title: 'Site View',
        type: 'link',
        icontype: 'place'
    },

    {
        path: '',
        title: 'Alerts',
        type: 'sub',
        icontype: 'add_alert',
        collapse: 'Alerts',
        children: [
            { path: 'alert-logs', title: 'Alert Log', ab: '' ,icontype: 'history'},
            { path: 'alert-settings', title: 'Alert Settings', ab: '' ,icontype: 'settings_applications'}
        ]
    },
    {
        path: '/site-audit',
        title: 'Site Audit',
        type: 'link',
        icontype: 'card_membership'
    },
    {
        path: '',
        title: 'Preventive Maintenance',
        type: 'sub',
        icontype: 'schedule',
        collapse: 'Preventive',
        children: [
            { path: 'preventive-maintenance', title: 'Preventive Maintenance', ab: '' ,icontype: 'library_add'}
        ]
    },
    {
        path: '/repair-maintenance',
        title: 'Repair & Maintenance',
        type: 'link',
        icontype: 'engineering'
    },
    {
        path: '/periodic-test',
        title: 'Periodic Test',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/custmer_complaints',
        title: 'Customer Complaints',
        type: 'link',
        icontype: 'local_police'
    },
    {
        path: '',
        title: 'Reports',
        type: 'sub',
        icontype: 'multiline_chart',
        collapse: 'Reports',
        children: [
            { path: '', title: 'Asset List', ab: 'AL', icontype: 'list' },
            // { path: '', title: 'User List', ab: 'UL', icontype: 'vertical_split' },
            { path: '', title: 'AMC & Subscription status', ab: 'AS', icontype: 'subscriptions' },
            { path: 'energy-consumption', title: 'Energy Consumption Report', ab: 'AS', icontype: 'description' },
            { path: 'hourly-energy-report', title: 'Hourly Energy Report', ab: 'AS', icontype: 'description' },
            { path: 'asset-health', title: 'Asset Health Report', ab: 'AS', icontype: 'description' }
        ]
    },
    {
        path: '',
        title: 'AMC',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'AMC',
        children: [
            { path: '', title: 'AMC', ab: 'AM', icontype: 'card_membership' },
            { path: '', title: 'Subscription', ab: 'SM', icontype: 'subscriptions' }
        ]
    },
     {
        path: '/asset-register',
        title: 'Asset Register',
        type: 'link',
        icontype: 'important_devices'
    },
    {
        path: '/help',
        title: 'Help',
        type: 'link',
        icontype: 'engineering'
    }
];

let clientmanager = [
    // {
    //     path: '/cms-dashboard',
    //     title: 'CMS Dashboard',
    //     type: 'sub',
    //     icontype: 'home',
    //     collapse: 'cmsdashboard',
    //     children: [
    //         { path: 'geo-view', title: 'Geo View', ab: 'GV', icontype: 'map' },
    //         { path: 'site-view', title: 'Site View', ab: 'SV', icontype: 'place' }

    //     ]
    // },

    {
        path: '/geo-view',
        title: 'Geo View',
        type: 'link',
        icontype: 'map'
    },
    {
        path: '/site-view',
        title: 'Site View',
        type: 'link',
        icontype: 'place'
    },
   
    {
        path: '',
        title: 'Alerts',
        type: 'sub',
        icontype: 'add_alert',
        collapse: 'Alerts',
        children: [
            { path: 'alert-logs', title: 'Alert Log', ab: '' ,icontype: 'history'},
            { path: 'alert-settings', title: 'Alert Settings', ab: '' ,icontype: 'settings_applications'}
        ]
    },
    {
        path: '/site-audit',
        title: 'Site Audit',
        type: 'link',
        icontype: 'card_membership'
    },
    {
        path: '',
        title: 'Preventive Maintenance',
        type: 'sub',
        icontype: 'schedule',
        collapse: 'Preventive',
        children: [
            { path: 'preventive-maintenance', title: 'Preventive Maintenance', ab: '' ,icontype: 'library_add'}
        ]
    },
    {
        path: '/repair-maintenance',
        title: 'Repair & Maintenance',
        type: 'link',
        icontype: 'engineering'
    },
    {
        path: '/periodic-test',
        title: 'Periodic Test',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/custmer_complaints',
        title: 'Customer Complaints',
        type: 'link',
        icontype: 'local_police'
    },
    {
        path: '',
        title: 'Reports',
        type: 'sub',
        icontype: 'multiline_chart',
        collapse: 'Reports',
        children: [
            { path: 'asset-list', title: 'Asset List', ab: 'AL', icontype: 'list' },
            { path: 'user-list', title: 'User List', ab: 'UL', icontype: 'vertical_split' },
            { path: '', title: 'AMC & Subscription status', ab: 'AS', icontype: 'subscriptions' },
            { path: 'energy-consumption', title: 'Energy Consumption Report', ab: 'AS', icontype: 'description' },
            { path: 'hourly-energy-report', title: 'Hourly Energy Report', ab: 'AS', icontype: 'description' },
            { path: 'asset-health', title: 'Asset Health Report', ab: 'AS', icontype: 'description' }
        ]
    },
    {
        path: '',
        title: 'AMC',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'AMC',
        children: [
            { path: 'amcmaster', title: 'AMC', ab: 'AM', icontype: 'card_membership' },
            { path: 'subscription', title: 'Subscription', ab: 'SM', icontype: 'subscriptions' }
        ]
    },
     {
        path: '/asset-register',
        title: 'Asset Register',
        type: 'link',
        icontype: 'important_devices'
    },
    {
        path: '/client-order-enquiry',
        title: 'Order Enquiry',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/help',
        title: 'Help',
        type: 'link',
        icontype: 'help_outline'
    }  
];

let clientsupervisior = [
    // {
    //     path: '/cms-dashboard',
    //     title: 'CMS Dashboard',
    //     type: 'sub',
    //     icontype: 'home',
    //     collapse: 'cmsdashboard',
    //     children: [
    //         { path: 'geo-view', title: 'Geo View', ab: 'GV', icontype: 'map' },
    //         { path: 'site-view', title: 'Site View', ab: 'SV', icontype: 'place' }

    //     ]
    // },

    {
        path: '/geo-view',
        title: 'Geo View',
        type: 'link',
        icontype: 'map'
    },
    {
        path: '/site-view',
        title: 'Site View',
        type: 'link',
        icontype: 'place'
    },
   
    {
        path: '',
        title: 'Alerts',
        type: 'sub',
        icontype: 'add_alert',
        collapse: 'Alerts',
        children: [
            { path: 'alert-logs', title: 'Alert Log', ab: '' ,icontype: 'history'},
            { path: 'alert-settings', title: 'Alert Settings', ab: '' ,icontype: 'settings_applications'}
        ]
    },
    {
        path: '/site-audit',
        title: 'Site Audit',
        type: 'link',
        icontype: 'card_membership'
    },
    {
        path: '',
        title: 'Preventive Maintenance',
        type: 'sub',
        icontype: 'schedule',
        collapse: 'Preventive',
        children: [
            { path: 'preventive-maintenance', title: 'Preventive Maintenance', ab: '' ,icontype: 'library_add'}
        ]
    },
    {
        path: '/repair-maintenance',
        title: 'Repair & Maintenance',
        type: 'link',
        icontype: 'engineering'
    },
    {
        path: '/periodic-test',
        title: 'Periodic Test',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/custmer_complaints',
        title: 'Customer Complaints',
        type: 'link',
        icontype: 'local_police'
    },
    {
        path: '',
        title: 'Reports',
        type: 'sub',
        icontype: 'multiline_chart',
        collapse: 'Reports',
        children: [
            // { path: '', title: 'Asset List', ab: 'AL', icontype: 'list' },
            // { path: '', title: 'User List', ab: 'UL', icontype: 'vertical_split' },
            { path: '', title: 'AMC & Subscription status', ab: 'AS', icontype: 'subscriptions' },
            { path: 'energy-consumption', title: 'Energy Consumption Report', ab: 'AS', icontype: 'description' },
            { path: 'hourly-energy-report', title: 'Hourly Energy Report', ab: 'AS', icontype: 'description' },
            { path: 'asset-health', title: 'Asset Health Report', ab: 'AS', icontype: 'description' }
        ]
    },
    {
        path: '',
        title: 'AMC',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'AMC',
        children: [
            { path: 'amcmaster', title: 'AMC', ab: 'AM', icontype: 'card_membership' },
            { path: 'subscription', title: 'Subscription', ab: 'SM', icontype: 'subscriptions' }
        ]
    },
     {
        path: '/asset-register',
        title: 'Asset Register',
        type: 'link',
        icontype: 'important_devices'
    },
    {
        path: '/client-order-enquiry',
        title: 'Order Enquiry',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/help',
        title: 'Help',
        type: 'link',
        icontype: 'engineering'
    }
];

let clienttechnician = [
    // {
    //     path: '/cms-dashboard',
    //     title: 'CMS Dashboard',
    //     type: 'sub',
    //     icontype: 'home',
    //     collapse: 'cmsdashboard',
    //     children: [
    //         { path: 'geo-view', title: 'Geo View', ab: 'GV', icontype: 'map' },
    //         { path: 'site-view', title: 'Site View', ab: 'SV', icontype: 'place' }

    //     ]
    // },
    {
        path: '/geo-view',
        title: 'Geo View',
        type: 'link',
        icontype: 'map'
    },
    {
        path: '/site-view',
        title: 'Site View',
        type: 'link',
        icontype: 'place'
    },
   
    {
        path: '',
        title: 'Alerts',
        type: 'sub',
        icontype: 'add_alert',
        collapse: 'Alerts',
        children: [
            { path: 'alert-logs', title: 'Alert Log', ab: '' ,icontype: 'history'},
            { path: 'alert-settings', title: 'Alert Settings', ab: '' ,icontype: 'settings_applications'}
        ]
    },
    {
        path: '/site-audit',
        title: 'Site Audit',
        type: 'link',
        icontype: 'card_membership'
    },
    {
        path: '',
        title: 'Preventive Maintenance',
        type: 'sub',
        icontype: 'schedule',
        collapse: 'Preventive',
        children: [
            { path: 'preventive-maintenance', title: 'Preventive Maintenance', ab: '' ,icontype: 'library_add'}
        ]
    },
    {
        path: '/repair-maintenance',
        title: 'Repair & Maintenance',
        type: 'link',
        icontype: 'engineering'
    },
    {
        path: '/periodic-test',
        title: 'Periodic Test',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/custmer_complaints',
        title: 'Customer Complaints',
        type: 'link',
        icontype: 'local_police'
    },
    {
        path: '',
        title: 'Reports',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'Reports',
        children: [
            // { path: '', title: 'Asset List', ab: 'AL', icontype: 'list' },
            // { path: '', title: 'User List', ab: 'UL', icontype: 'vertical_split' },
            { path: '', title: 'AMC & Subscription status', ab: 'AS', icontype: 'subscriptions' },
            { path: 'energy-consumption', title: 'Energy Consumption Report', ab: 'AS', icontype: 'description' },
            { path: 'hourly-energy-report', title: 'Hourly Energy Report', ab: 'AS', icontype: 'description' },
            { path: 'asset-health', title: 'Asset Health Report', ab: 'AS', icontype: 'description' }
        ]
    },
    {
        path: '',
        title: 'AMC',
        type: 'sub',
        icontype: 'card_membership',
        collapse: 'AMC',
        children: [
            { path: 'amcmaster', title: 'AMC', ab: '',icontype: 'place' },
            { path: 'subscription', title: 'Subscription', ab: '' ,icontype: 'place'}
        ]
    },
     {
        path: '/asset-register',
        title: 'Asset Register',
        type: 'link',
        icontype: 'important_devices'
    },
    {
        path: '/client-order-enquiry',
        title: 'Order Enquiry',
        type: 'link',
        icontype: 'assignment'
    },
    {
        path: '/help',
        title: 'Help',
        type: 'link',
        icontype: 'help_outline'
    }
    ,
    

];

export const ROUTES: RouteInfo[] = [];


let usertype = JSON.parse(localStorage.getItem("user")) == null ? "none" : JSON.parse(localStorage.getItem("user")).userType;

if (usertype == "none") {

} else if (usertype == "admin") {
    for (let i = 0; i < adminMenu.length; i++) {
        ROUTES.push(adminMenu[i]);
    }
} else if (usertype == "sales manager") {
    for (let i = 0; i < salesmanager.length; i++) {
        ROUTES.push(salesmanager[i]);
    }
} else if (usertype == "customer service executive") {
    for (let i = 0; i < customerserviceexecutive.length; i++) {
        ROUTES.push(customerserviceexecutive[i]);
    }
} else if (usertype == "field engineer") {
    for (let i = 0; i < fieldengineer.length; i++) {
        ROUTES.push(fieldengineer[i]);
    }
} else if (usertype == "client manager") {
    //client manager
    for (let i = 0; i < clientmanager.length; i++) {
        ROUTES.push(clientmanager[i]);
    }
} else if (usertype == "client supervisior") {
    //client supervisior
    for (let i = 0; i < clientsupervisior.length; i++) {
        ROUTES.push(clientsupervisior[i]);
    }
} else if (usertype == "client technician") {
    //client technician
    for (let i = 0; i < clienttechnician.length; i++) {
        ROUTES.push(clienttechnician[i]);
    }
}


@Component({
    selector: 'app-sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {
    public menuItems: any[];
    ps: any;
    companyName: string;
    isMobileMenu() {
        if ($(window).width() > 991) {
            return false;
        }
        return true;
    };

    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            const elemSidebar = <HTMLElement>document.querySelector('.sidebar .sidebar-wrapper');
            this.ps = new PerfectScrollbar(elemSidebar);
        }

        this.companyName = JSON.parse(localStorage.getItem('user'))?.user?.companyname;




    }
    updatePS(): void {
        if (window.matchMedia(`(min-width: 960px)`).matches && !this.isMac()) {
            this.ps.update();
        }
    }
    isMac(): boolean {
        let bool = false;
        if (navigator.platform.toUpperCase().indexOf('MAC') >= 0 || navigator.platform.toUpperCase().indexOf('IPAD') >= 0) {
            bool = true;
        }
        return bool;
    }
}
